/**
 * Обертка рисковой сцены (по идее любой и красночерной и 4х карточной)
 * @param {RiskScene} riskScene - готовая рисковая сцена
 * @param {Stream} $ticker - поставщик dt (для обновлений если это требуется в сцене)
 * */

import { stateWinInCoins, RISK_WIN_MULT, RISK_TYPE } from "./network/network_api"
import { get_prop } from 'utils'

export default function RiskView(
    riskScene,
    parent,
    $ticker,
)
{
    const space = parent.child( "risk" );
    
    if (!riskScene) {
        return {
            space
        }
    }
    
    // карта, которую выбрал игрок
    const $choiceOut = space.s( "choiceOut" );
    
    riskScene.controller = {
        cardSelected( card, step ) {
            $choiceOut.next( card )
        }
    }
    
    riskScene.visible = false;
    
    if ( riskScene.update )
    {
        $ticker.subscribe(dt => {
            riskScene.update(dt);
        });
    }
    
    const $startComplete = space.s( "startComplete" );
    // вход в риск
    // требуются текущий выигрыш и тот который будет
    // требуется история карт
    space.s( "startRound" ).subscribe( enter => {
        riskScene.visible = true;
        if ( riskScene.startRound ) riskScene.startRound( enter, $startComplete )
    } );
    
    
    const $enterComplete = space.s( "enterComplete" );
    
    // вход - отрисовка каких-то вещей которые на затрагиваются в отрисовке в startRound()
    space.s( "enter" ).subscribe( state => {
        riskScene.visible = true;
        if ( riskScene.resume ) riskScene.resume( state )
        $enterComplete.next();
        space.s('result_win').next(stateWinInCoins( state.state ));
    } );
    
    // выход - отключение звука мелькающей карты и т.п.
    space.s( "leave" ).subscribe( state => {
        if ( riskScene.pause ) riskScene.pause(state);
        riskScene.visible = false;
    } );
    
    // сигнализирует о том что длительный показ исхода риска польностью завершился
    const $showComplete = space.s( "showComplete" );
    
    // требуется результат и сумма выигрыша которую отобразить и ту которую показать как следующий возможной выигрыш
    // могут быть нулями если игрок проиграл
    space.s( "result" )
        .map( ({ state, result }) => {
            riskScene.visible = true
            
            //в конструкторе сцен задаётся меткам "0" и дальнейшие [актуальные] значения задаются в startRound, но при восстановлении на сразу состоянии результата раунда риска на время переворота карты видны нулю, поэтому просто реплицируем (конструкторов вообще быть не должно):
            let win = 0;
            if (result.processed.forward) {
                win = ( stateWinInCoins( state.state ) ) || get_prop( state.state, [ 'previous_state', 'open_win' ], 0 );
            }
            else {
                win = ( stateWinInCoins(state.state) / RISK_WIN_MULT ) || get_prop(state.state, ['previous_state', 'open_win'], 0)
            }
            const potential_win = state.state.risk_possible ? win * RISK_WIN_MULT : '';
            const current_win_label = riskScene.currentWinLabel
            if ( current_win_label ) current_win_label.text = win
            else console.log( "Risk current win label was NOT resoled!!!!" )
            const future_win_label = riskScene.nextWinLabel || riskScene.possibleWinLabel
            if ( future_win_label ) future_win_label.text = potential_win
            else console.log( "Risk future win label was NOT resolved!!!!" )
            
            if ( riskScene.showRiskResult ) riskScene.showRiskResult( result, () => $showComplete.next(), state )
            
            return stateWinInCoins( state.state )
        } )
    
    space.s( "collect" ).subscribe(() => riskScene.disableInteraction && riskScene.disableInteraction());
    
    // игрок сделал выбор - отобразилась информация о том какой цвет он выбрал (даьше ничего не происходит)
    space.s( "choiceIn" ).subscribe( choice => {
        if ( riskScene.onCardSelect ) riskScene.onCardSelect( choice );
        if ( riskScene.disableInteraction ) riskScene.disableInteraction();
    } );
    
    return {
        view:riskScene,
        space,
    }
}



// WEBPACK FOOTER //
// ./src/library/risk_view.es6